import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import platform from 'rangeConfig/shared/utils/platform';
import { DynamicSizeTitle } from 'rangeConfig/billy/widgets/DynamicSizeTitle/DynamicSizeTitle';
import { doorsProductListConfig } from './productListConfig';
import * as R from 'ramda';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import { colorFilter } from 'rangeConfig/billy/filters/configFilters';
import { heightFilterWithSizeLabel } from 'rangeConfig/shared/filters/configFilters';
import { forgetDoorChoices } from 'rangeConfig/billy/behaviours/forgetDoorChoices';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { CoreApi } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import { getNoFramesInSceneErrorMessage } from 'rangeConfig/shared/utils/errorMessages';
import {
  sortByName,
  sortByPriceAscending,
  sortByPriceDescending
} from 'rangeConfig/shared/sorting/sortingConfigs';

const Doorsh1920 = R.pipe(withCategoryFilter(['doors-h1920']));
const Doorsh970 = R.pipe(withCategoryFilter(['doors-h970']));
const Doorsh350 = R.pipe(withCategoryFilter(['doors-h350']));

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    },
    {
      id: 'doors-sort-filter-widget',
      component: ProductSortFilterWidget
    },
    {
      id: 'doors-product-list',
      component: withProducts(ProductList, doorsProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'doors-product-list-1920',
      component: Doorsh1920(withProducts(ProductSwiper, doorsProductListConfig)),
      title: () => DynamicSizeTitle({ translationKey: 'storageone.height', size: 1920 })
    },
    {
      id: 'doors-product-list-970',
      component: Doorsh970(withProducts(ProductSwiper, doorsProductListConfig)),
      title: () => DynamicSizeTitle({ translationKey: 'storageone.height', size: 970 })
    },
    {
      id: 'doors-product-list-350',
      component: Doorsh350(withProducts(ProductSwiper, doorsProductListConfig)),
      title: () => DynamicSizeTitle({ translationKey: 'storageone.height', size: 350 })
    }
  ]
};

const filters = {
  desktop: [colorFilter, heightFilterWithSizeLabel],
  mobile: [colorFilter]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListDoorsTitle',
  behaviors: {
    productGroupEntered: [showDoors],
    productGroupExited: [forgetDoorChoices]
  },
  sorting: [sortByName, sortByPriceAscending, sortByPriceDescending],
  filters: filters[platform],
  widgets: widgets[platform]
};

export default mainMenu;
